<div style="position: relative">
  <h4 class="advancedFilter custom-panel-title" style="text-align: center; background: #03a9f4; padding: 15px; color: white; margin-top: 0">
    {{ rGuestBookMessages.rooms.advancedFilterHeader}}
  </h4>
  <button
    type="button"
    class="close"
    style="position: absolute; top: 14%; right: 3%; color: white; font-size: 30px"
    (click)="closeFilter();">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
</div>
<button
  class="clearAdvancedFilter"
  mat-stroked-button
  color="primary"
  (click)="clearFilter();filterSectionForm.reset();"
  style="float: right; margin: 2%">
  {{rGuestBookMessages.rooms.advancedFilterClrBtn}}
</button>

<form #filterSectionForm [formGroup]="filterForm" style="padding: 10px 10px 30px">
  <div style="clear: both; margin: 0">
    <div *ngFor="let filter of filters;let i = index;">
      <div
        [ngClass]="{'col-sm-12 col-lg-12': filters.length > 4 ,'col-sm-12': filters.length == 1}"
        [style.clear]="i%2 == 0 ? 'both' : null">
        <mat-form-field *ngIf="filter.type == 'textbox'">
          <input
            matInput
            placeholder="{{filter.label}}"
            [formControlName]="filter.mappingField+filter.order"
            [(ngModel)]="filtervalueObj['searchText'+filter.mappingField+filter.order]"
            [name]="filter.mappingField+filter.order"
            autocomplete="off"
            (input)="filterItem()" />
        </mat-form-field>
        <mat-form-field *ngIf="filter.type == 'dropdown'">
          <mat-label>{{filter.label}}</mat-label>
          <mat-select
            [formControlName]="filter.mappingField+filter.order"
            multiple
            [(ngModel)]="filtervalueObj['searchText'+filter.mappingField+filter.order]"
            (selectionChange)="filterItem()">
            <!-- <mat-option></mat-option> -->
            <mat-option *ngFor="let filterValue of filter.values" [value]="filterValue.key"> {{filterValue.value}} </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="filter.type == 'radio'">
          <label style="color: #949494; font-weight: normal !important; font-size: 14px">{{filter.label}} </label>
          <div class="mat-form-field">
            <mat-radio-group
              [formControlName]="filter.mappingField+filter.order"
              [(ngModel)]="filtervalueObj['searchText'+filter.mappingField+filter.order]"
              [name]="filter.mappingField+filter.order"
              (ngModelChange)="filterItem()">
              <mat-radio-button style="margin-right: 0.5rem" *ngFor="let filterValue of filter.values" [value]="filterValue.key"
                >{{filterValue.value}}</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
